export default __webpack_public_path__ + "static/media/harley.38a6051f.jpg";